<!--
� 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
-->

<div class="pagination">
	<span>
		{{ currentPage * pageSize + 1 }} -
		{{ currentPage * pageSize + pageItems }}
		<span class="total-items">of {{ totalItems }}</span>
	</span>

	<div class="pagination-buttons">
		<globalictcc-button
			size="small"
			[iconOnly]="true"
			iconName="chevron-left"
			[disabled]="currentPage === 0"
			(handleClick)="handlePreviousPage.emit()"
		/>

		<globalictcc-button
			size="small"
			[iconOnly]="true"
			iconName="chevron-right"
			[disabled]="currentPage === totalPages - 1"
			(handleClick)="handleNextPage.emit()"
		/>
	</div>
</div>
